import Flickity from 'flickity';

/*
* 4 Up Carousel
* @param {object} opts
*/

function fourUpCarousel(opts) {
  const config = {
    dom: {
      carousel: 'js-four-up-carousel',
    },
    flickityOpts: {
      prevNextButtons: false,
      pageDots: true,
      draggable: true,
      wrapAround: true,
      imagesLoaded: true,
      lazyLoad: true,
      adaptiveHeight: false,
    },
  };

  const c = __.extend(config, opts);
  const $carousels = document.body.querySelectorAll(`.${c.dom.carousel}`);
  let view = null;

  /**
   * Init
   */
  function init() {
    if (!$carousels?.length) return;
    onWindowResize();
    __.windowResize(onWindowResize);
  }

  /**
  * Responsive functions
  */
  function onWindowResize() {
    __.mq({
      view: 'tablet',
      callback: () => {
        if (view !== 'tablet') {
          view = 'tablet';
          destroyCarousel();
        }
      },
    });

    __.mq({
      view: 'phone',
      callback: () => {
        if (view !== 'phone') {
          view = 'phone';
          createCarousel(c.flickityOpts);
        }
      },
    });
  }

  /**
   * Create Carousel
   * @param {object} opts.flickityOpts
   */
  function createCarousel(flickityOpts) {
    $carousels.forEach(($carousel) => {
      let flickity = Flickity.data($carousel);
      if (flickity) flickity.destroy();

      setTimeout(() => {
        flickity = new Flickity($carousel, flickityOpts);
      }, 500);
    });
  }

  /**
   * Destroy Carousel
   */
  function destroyCarousel() {
    $carousels.forEach(($carousel) => {
      const flickity = Flickity.data($carousel);
      if (flickity) flickity.destroy();
    });
  }

  return init();
}

export default fourUpCarousel;
